import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import Maintenance from "@/components/Maintenance";

const KEY_STORAGE = "gv_access_key";

/** Region gate: shows the maintenance screen to visitors from blocked countries.
 *  Admin routes always render so Gemma can sign in from any network. */
export default function RegionGate({ children }) {
  const { pathname, search } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    const fromUrl = new URLSearchParams(search).get("access");
    if (fromUrl) localStorage.setItem(KEY_STORAGE, fromUrl);
    const key = fromUrl || localStorage.getItem(KEY_STORAGE) || "";

    api
      .get("/access/check", { headers: key ? { "X-Access-Key": key } : {} })
      .then(({ data }) => setAllowed(data.allowed !== false))
      .catch(() => setAllowed(true)); // never lock people out on a network error
  }, [search]);

  if (isAdminRoute) return children;
  if (allowed === null) return <div className="min-h-screen bg-[#FAFAF8]" data-testid="region-gate-loading" />;
  if (!allowed) return <Maintenance />;
  return children;
}
